import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { Link as RouterLink } from 'react-router-dom'
import { formatTime } from './utils'
import { stringToColor } from 'lib/string-to-color'

export default function EventCard({ event, hourStart, lane, totalLanes }) {
  const from = new Date(event.from)
  const to = new Date(event.to)
  const topMinutes = (from.getHours() - hourStart) * 60 + from.getMinutes()
  const durationMinutes = (to - from) / 60000
  // 60px per hour = 1px per minute
  const top = topMinutes
  const height = Math.max(durationMinutes, 20) // minimum 20px height

  const bgColor = stringToColor(event.teacher)
  const widthPercent = 100 / totalLanes
  const leftPercent = lane * widthPercent

  return (
    <Box
      component={RouterLink}
      to={`/groups/details/${event.groupId}/lesson/${event.id}`}
      sx={{
        position: 'absolute',
        top: `${top}px`,
        left: `${leftPercent}%`,
        width: `calc(${widthPercent}% - 2px)`,
        height: `${height}px`,
        bgcolor: bgColor,
        color: '#fff',
        borderRadius: 1,
        px: 0.5,
        py: 0.25,
        overflow: 'hidden',
        cursor: 'pointer',
        fontSize: '0.75rem',
        lineHeight: 1.2,
        boxSizing: 'border-box',
        textDecoration: 'none',
        '&:hover': {
          opacity: 0.85,
          boxShadow: 2,
        },
      }}
      title={`${event.group} — ${event.teacher}\n${formatTime(from)} – ${formatTime(to)}`}
    >
      <Typography
        variant="caption"
        sx={{ color: 'inherit', fontWeight: 600, display: 'block', lineHeight: 1.2, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
      >
        {event.group}
      </Typography>
      {height >= 40 && (
        <Typography
          variant="caption"
          sx={{ color: 'inherit', display: 'block', lineHeight: 1.2, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
        >
          {event.teacher}
        </Typography>
      )}
      {height >= 55 && (
        <Typography
          variant="caption"
          sx={{ color: 'inherit', opacity: 0.85, display: 'block', lineHeight: 1.2 }}
        >
          {formatTime(from)} – {formatTime(to)}
        </Typography>
      )}
    </Box>
  )
}
